import { render, staticRenderFns } from "./RipaStopResult.vue?vue&type=template&id=0e9680b2"
import script from "./RipaStopResult.vue?vue&type=script&lang=js"
export * from "./RipaStopResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports